var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon-stroke",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.946L.75 9.196M.75 18c3.837-1.28 7.241-3.603 9.83-6.71l.234-.28c.7-.841-.3-2.032-1.383-1.532L3.685 12.13M16.53 11.25l-3.3 4.091c-.336.424-.943.515-1.389.209l-.12-.082c-.395-.275-.563-.777-.413-1.234l.271-.834M18.271 11.25l-.86 4.409c-.061.317-.265.588-.552.735-.284.144-.62.144-.905 0l-.281-.145c-.348-.181-.566-.542-.564-.935v-2.3M18.75 0h3c.828 0 1.5.672 1.5 1.5v8.25c0 .828-.672 1.5-1.5 1.5H13.5M5.25 8.25V1.5c0-.828.672-1.5 1.5-1.5h3.75",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.579 6.344c.44.577 1.133.904 1.858.875 1.139 0 2.063-.693 2.063-1.547s-.924-1.546-2.063-1.546c-1.139 0-2.062-.693-2.062-1.548 0-.855.924-1.547 2.062-1.547.725-.03 1.419.297 1.858.875M14.437 7.219L14.437 8.25M14.437 0L14.437 1.031",
    transform: "translate(0 1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpense);
export default __webpack_public_path__ + "static/media/expense.f43a3829ee845004ab341b0f684750cb.svg";
export { ForwardRef as ReactComponent };